import * as React from "react";
const SvgFiRrRestaurant = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-restaurant_svg__a)">
      <path
        fill="#062147"
        d="M1.333 7.238C.483 5.522-1.2 1.268 1.2.15a1.95 1.95 0 0 1 2.129.423l4.96 5.3A1 1 0 1 1 6.887 7.3L2 2.08c.119 3.777 2.343 6.6 4.84 9.439a1.003 1.003 0 1 1-1.39 1.446 24.5 24.5 0 0 1-4.117-5.727M18.005 16.2a1.26 1.26 0 0 0-1.09-.4 8.06 8.06 0 0 1-3.458-.29.99.99 0 0 0-.981.254c-1.494 2.256 3.274 2.113 4.312 2.08l5.483 5.839a1.001 1.001 0 0 0 1.458-1.371zM15 14a5 5 0 0 0 3.536-1.462l5.17-5.172a1.001 1.001 0 1 0-1.413-1.416l-5.171 5.172a3 3 0 0 1-3.406.576l6.99-6.991a1 1 0 1 0-1.413-1.414l-6.993 6.99a3 3 0 0 1 .576-3.405l5.174-5.171A1 1 0 0 0 16.636.293l-5.172 5.17a5.01 5.01 0 0 0-.635 6.294L.293 22.293a1 1 0 0 0 1.414 1.414L12.243 13.17A5 5 0 0 0 15 14"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-restaurant_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRestaurant;
